module.exports = __webpack_public_path__ + "static/media/king-of-strings.602929f8.jpg";